import React from "react";
import { NavLink } from "react-router-dom";

export default function Header() {
  return (
    <header className="masthead mb-auto">
      <div className="inner">
        <nav className="nav nav-masthead justify-content-center">


          <NavLink
            to="/firstpage"
            className={({ isActive }) =>
              'nav-link' + (isActive ? ' active' : '')
            }
          >
            Home
          </NavLink>


          <NavLink
            to="/technologyprojects"
            className={({ isActive }) =>
              'nav-link' + (isActive ? ' active' : '')
            }
          >
            Technology Projects
          </NavLink>


          <NavLink
            to="/artpieces"
            className={({ isActive }) =>
              'nav-link' + (isActive ? ' active' : '')
            }
          >
            Art Pieces
          </NavLink>


          <NavLink
            to="/recipes"
            className={({ isActive }) =>
              'nav-link' + (isActive ? ' active' : '')
            }
          >
            Recipes
          </NavLink>


          <NavLink
            to="/traveling"
            className={({ isActive }) =>
              'nav-link' + (isActive ? ' active' : '')
            }
          >
            travel
          </NavLink>
          
          <NavLink
            to="/ContactPage"
            className={({ isActive }) =>
              'nav-link' + (isActive ? ' active' : '')
            }
          >
            Contact Me
          </NavLink>



        </nav>
      </div>
    </header>
  );
}